

























































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';

@Component
export default class VehicleVehiclesDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public items: object[] = [];
}
